export default "__VITE_ASSET__756f9f96__"